import { useState } from 'react';
import type { ProductDocument } from 'models/product';
import { PlaceABidForm } from 'features/auctions/forms/PlaceABidForm';
import MobileDrawer from '../../../components/drawers/MobileDrawer';
import { ChevronLeftIcon } from '@heroicons/react/20/solid';

type MobilePlaceABidModalProps = {
  show: boolean;
  dismiss: () => void;
  product: ProductDocument;
};

export default function MobilePlaceABidModal({
  show,
  dismiss,
  product,
}: MobilePlaceABidModalProps) {
  const [currentStep, setCurrentStep] = useState(0);

  const handleBackButtonClick = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleDismiss = () => {
    setCurrentStep(0);
    dismiss();
  };

  return (
    <MobileDrawer
      show={show}
      dismiss={handleDismiss}
      title="Place a Bid"
      headerExtraButton={
        currentStep > 0 ? (
          <button
            type="button"
            onClick={handleBackButtonClick}
            className="rounded-full bg-[#F6F6F6] p-4"
          >
            <ChevronLeftIcon className="h-[3rem] w-[3rem] text-zinc-600" />
          </button>
        ) : undefined
      }
    >
      <PlaceABidForm
        product={product}
        onSubmitSuccess={handleDismiss}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        isMobile
      />
    </MobileDrawer>
  );
}
